import React from "react";
import { message, Spin } from "antd";
import Button from "../../components/Button";
import Bridge from "../../constants/Bridge";
import URLs, { BASE_URL } from "../../constants/Apis";

class ResetPassword extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      password: "",
      new_password: "",
      confirm_password: "",
      newPassType: "password",
      confirmPassType: "password",
      loading: false,
    };
  }
  componentDidMount() {
    if (!localStorage.getItem("forgot_verified")) {
      window.location.assign("/");
      return;
    }
  }
  // login
  reset_password = () => {
    if (!this.state.new_password) {
      message.warning("New Password is required");
      return;
    } else if (!this.state.confirm_password) {
      message.warning("Confirm Password is required");
      return;
    }
    if (this.state.new_password != this.state.confirm_password) {
      message.warning(
        "Both new and confirm password is not matching.Please try again."
      );
      return;
    }
    let params = {
      email: localStorage.getItem("forgot_email"),
      new_password: this.state.new_password,
      confirm_password: this.state.confirm_password,
    };
    this.setState({ loading: true });
    Bridge.forgotPassword.resetPassword(params).then((res) => {
      if (res.status == 1) {
        localStorage.removeItem("forgot_email");
        localStorage.removeItem("forgot_verified");
        message.success(
          "Password is changed successfully. Please try to login."
        );
        this.setState(
          {
            loading: false,
          },
          () => {
            setTimeout(() => {
              window.location.assign("/");
            }, 3000);
          }
        );
      } else {
        message.warning(res.message);
        this.setState({ loading: false });
        return;
      }
    });
  };
  // toggle password
  toogle_password_type = (param) => {
    if (param == "new") {
      let type = this.state.newPassType == "password" ? "text" : "password";
      this.setState({
        newPassType: type,
      });
    } else if (param == "confirm") {
      let type = this.state.confirmPassType == "password" ? "text" : "password";
      this.setState({
        confirmPassType: type,
      });
    }
  };
  render() {
    return (
      <div
        className="multisteps-form__panel js-active login-page"
        data-animation="slideVert"
      >
        <div className="inner pb-50">
          <div
            className="wizard-content-item text-center"
            style={{ paddingTop: 0 }}
          >
            <div
              className="wizard-content-item text-center"
              style={{ paddingTop: 0 }}
            >
              <img
                src="/assets/img/ecas-logo-white.png"
                className="logo-img"
                style={{
                  margin: "0 auto",
                  marginBottom: 0,
                  maxWidth: 220,
                  width: 240,
                }}
              />
              <h2>
                EALS Consortia Portal
                <br /> Reset Passsword
              </h2>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-4 m-auto">
              <div className="wizard-content-form">
                <Spin spinning={this.state.loading}>
                  <div className="wizard-form-field">
                    <div className="wizard-form-input position-relative form-group has-float-label">
                      <input
                        type={this.state.newPassType}
                        onChange={(e) =>
                          this.setState({ new_password: e.target.value })
                        }
                        value={this.state.new_password}
                        className="form-control"
                        name="password"
                        placeholder="New Password"
                      />
                      <label>New Password</label>
                      <div
                        className="togglePassword"
                        onClick={() => this.toogle_password_type("new")}
                      >
                        {this.state.newPassType == "password" ? (
                          <i className="fas fa-eye-slash"></i>
                        ) : (
                          <i className="fas fa-eye"></i>
                        )}
                      </div>
                    </div>
                    <div className="wizard-form-input position-relative form-group has-float-label">
                      <input
                        type={this.state.confirmPassType}
                        onChange={(e) =>
                          this.setState({ confirm_password: e.target.value })
                        }
                        value={this.state.confirm_password}
                        className="form-control"
                        name="password"
                        placeholder="Confirm Password"
                      />
                      <label>Confirm Password</label>
                      <div
                        className="togglePassword"
                        onClick={() => this.toogle_password_type("confirm")}
                      >
                        {this.state.confirmPassType == "password" ? (
                          <i className="fas fa-eye-slash"></i>
                        ) : (
                          <i className="fas fa-eye"></i>
                        )}
                      </div>
                    </div>
                    <center>
                      <Button
                        to="#"
                        isClickable={true}
                        click={() => this.reset_password()}
                        style={{ width: "fit-content" }}
                      >
                        <i className="fa fa-arrow-right" aria-hidden="true"></i>
                        &nbsp;&nbsp; Change Password
                      </Button>
                    </center>
                  </div>
                </Spin>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default ResetPassword;
